import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "top-form-selector flex flex-wrap align-items-center p-4 pb-0" }
const _hoisted_2 = { class: "mr-4 mb-3" }
const _hoisted_3 = { class: "flex flex-wrap mb-3" }
const _hoisted_4 = { class: "flex align-items-center mx-0 pr-3" }
const _hoisted_5 = { class: "flex align-items-center pr-3" }
const _hoisted_6 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "p-0"
}
const _hoisted_8 = { class: "flex flex-row justify-content-end" }

import { ref, onMounted, toRefs, provide, watch } from 'vue';
import useVuelidate from '@vuelidate/core';

import Dialog from 'primevue/dialog';
import SelectButton from 'primevue/selectbutton';

import OrganizationContractMainForm from './OrganizationContractMainForm.vue';
import OrganizationContractDisciplines from './OrganizationContractDisciplines.vue';
import OrganizationContractClinicians from './OrganizationContractClinicians.vue';

import { ContractDetailInterface, DisciplineInterface } from '@/types';
import { CONTRACT_ENUMS, EMIT } from '@/enum';
import { useOrganizationContractsStore } from '@/store';

interface PropsInterface {
  id?: number;
}

const scope = 'contract_validation_scope';

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationContractModal',
  props: {
    id: {}
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const contractStore = useOrganizationContractsStore();
const displayModal = ref(true);
const contract = ref<ContractDetailInterface>({} as ContractDetailInterface);
const selectedForm = ref<CONTRACT_ENUMS.FORMS>(CONTRACT_ENUMS.FORMS.FLAT_FEE);
const props = __props;
const { id } = toRefs(props);
const canEdit = contractStore.canEditOrCreateContracts;

onMounted(async () => {
  contract.value = contractStore.contract;
  checkDisciplinesForBillingType();
});

const v$ = useVuelidate({ $scope: scope });

const billingTypes = [
  { id: CONTRACT_ENUMS.FORMS.FLAT_FEE, name: CONTRACT_ENUMS.CONTRACT_BILLING_TYPE.FLAT_FEE, label: 'Flat Fee' },
  { id: CONTRACT_ENUMS.FORMS.HOURLY, name: CONTRACT_ENUMS.CONTRACT_BILLING_TYPE.HOURLY, label: 'Hourly' },
  {
    id: CONTRACT_ENUMS.FORMS.PER_STUDENT,
    name: CONTRACT_ENUMS.CONTRACT_BILLING_TYPE.PER_STUDENT,
    label: 'Per Student',
  },
];

/**
 * Handle the closing of the create modal.
 */
const onCancel = () => {
  contractStore.pendingRequests = [];
  displayModal.value = false;
  emit(EMIT.CANCEL);
};

watch(selectedForm, (newForm) => {
  findBillingTypeNameById(newForm);
});

const findBillingTypeNameById = (id: number) => {
  contractStore.contract.billing_type = billingTypes.find((item) => item.id === id)?.name;
};

const checkDisciplinesForBillingType = () => {
  if (contract.value.disciplines.length) {
    const contractType = (contract.value.disciplines[0] as DisciplineInterface).contract_type;
    const billingType = billingTypes.find((item) => item.name === contractType);
    selectedForm.value = billingType?.id ?? 0;

    findBillingTypeNameById(selectedForm.value);
  } else {
    contractStore.contract.billing_type = billingTypes[0].name;
  }
};

/**
 * Handle the saving and closing of the modal.
 */
const onSave = async () => {
  contractStore.contract = contract.value;
  contractStore.contract.billing_type = billingTypes.find((item) => item.id === selectedForm.value)?.name;
  const validated = await v$.value.$validate();
  if (!validated) {
    const failingFormElement =
      document.querySelectorAll('.p-invalid')[0] || document.querySelector('.top-form-selector');

    failingFormElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });

    return;
  }
  displayModal.value = false;

  if (id?.value && contractStore.editType == CONTRACT_ENUMS.CONTRACT_EDIT_TYPES.EDIT) {
    await contractStore
      .save()
      .then(() => contractStore.doToast('Contract has been saved', 'Success'))
      .catch(() => {
        contractStore.doToast('Error saving contract, contact eLuma support', 'Error', true);
        emit(EMIT.CANCEL);
        return;
      });
  } else {
    await contractStore
      .createContract()
      .then(() => contractStore.doToast('Contract has been created', 'Success'))
      .catch(() => {
        contractStore.doToast('Error creating contract, contact eLuma support', 'Error', true);
        emit(EMIT.CANCEL);
        return;
      });
  }
  emit(EMIT.SAVE);
};

//provide the form type for subchildren
provide('selectedForm', selectedForm);

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: displayModal.value,
    "onUpdate:visible": [
      _cache[4] || (_cache[4] = ($event: any) => ((displayModal).value = $event)),
      onCancel
    ],
    modal: true,
    header: `Contract for ${_unref(contractStore).organizationName}`,
    draggable: false,
    position: "center",
    breakpoints: { '2200px': '75vw', '1600px': '85vw', '1200px': '100vw', '960px': '100vw' },
    class: "contract-modal w-6",
    "content-class": "p-0 bg-white overflow-x-hidden"
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(SelectButton), {
            modelValue: selectedForm.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedForm).value = $event)),
            unselectable: false,
            options: billingTypes,
            disabled: _unref(contractStore).editType == _unref(CONTRACT_ENUMS).CONTRACT_EDIT_TYPES.EDIT || !_unref(canEdit),
            "option-label": "label",
            "option-value": "id"
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(contractStore).loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "24px",
                  width: "47px"
                }))
              : (_openBlock(), _createBlock(_component_InputSwitch, {
                  key: 1,
                  id: "prepay",
                  modelValue: contract.value.prepay,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contract.value.prepay) = $event)),
                  class: "switch",
                  "true-value": 1,
                  "false-value": 0,
                  disabled: !_unref(canEdit)
                }, null, 8, ["modelValue", "disabled"])),
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "prepay",
              class: "ml-2 font-semibold"
            }, "Prepay", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_unref(contractStore).loading)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "24px",
                  width: "47px"
                }))
              : (_openBlock(), _createBlock(_component_InputSwitch, {
                  key: 1,
                  id: "third_party",
                  modelValue: contract.value.third_party,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contract.value.third_party) = $event)),
                  class: "switch",
                  "true-value": 1,
                  "false-value": 0,
                  disabled: !_unref(canEdit)
                }, null, 8, ["modelValue", "disabled"])),
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "third_party",
              class: "ml-2 font-semibold"
            }, "3rd Party", -1))
          ]),
          (selectedForm.value === _unref(CONTRACT_ENUMS).FORMS.HOURLY)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_unref(contractStore).loading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "24px",
                      width: "47px"
                    }))
                  : (_openBlock(), _createBlock(_component_InputSwitch, {
                      key: 1,
                      id: "third_party",
                      modelValue: contract.value.fee_for_service,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contract.value.fee_for_service) = $event)),
                      class: "switch",
                      "true-value": 1,
                      "false-value": 0,
                      disabled: !_unref(canEdit)
                    }, null, 8, ["modelValue", "disabled"])),
                _cache[7] || (_cache[7] = _createElementVNode("label", {
                  for: "third_party",
                  class: "ml-2 font-semibold"
                }, "Fee For Service", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (contract.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(OrganizationContractMainForm, {
              scope: scope,
              contract: contract.value,
              loading: _unref(contractStore).loading
            }, null, 8, ["contract", "loading"]),
            (contract.value.disciplines.length)
              ? (_openBlock(), _createBlock(OrganizationContractDisciplines, {
                  key: 0,
                  scope: scope,
                  loading: _unref(contractStore).loading
                }, null, 8, ["loading"]))
              : _createCommentVNode("", true),
            _createVNode(OrganizationContractClinicians, {
              clinicians: contract.value.clinicians,
              loading: _unref(contractStore).loading
            }, null, 8, ["clinicians", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_unref(canEdit))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_AppButton, {
                id: "cancel_btn",
                type: "secondary",
                text: "Cancel",
                onClick: onCancel
              }),
              _createVNode(_component_AppButton, {
                id: "save_btn",
                type: "primary",
                text: "Save",
                onClick: onSave
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["visible", "header"]))
}
}

})